module.exports = __webpack_public_path__ + "img/maropost-marketing-cloud.88ec9d28.webp";